module.exports = __webpack_public_path__ + "media/images/features/refund/heading-mv-b7725511c750618f5cda08707521817f.svg";